// extracted by mini-css-extract-plugin
module.exports = {"hero":"contact-module--hero--1h2T1","contact_section":"contact-module--contact_section--13jgc","contact_info":"contact-module--contact_info--2Urxo"};